import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../lib/useAuth'
import AuthLayout, { Field, SubmitButton, GoogleButton, Divider, Notice, AltLine } from '../components/AuthLayout'
import AuthWorkspaceStep from '../components/AuthWorkspaceStep'

/** /signin — email + password, Continue with Google, forgot + sign-up links. */
export default function SignIn() {
  const auth = useAuth({ mode: 'signin' })
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  // Carry the post-login destination through to sign-up / forgot links.
  const nextQ = auth.next && auth.next !== '/' ? `?next=${encodeURIComponent(auth.next)}` : ''

  // First-time user with no tenant yet → name the workspace (same card + theme).
  if (auth.pending) {
    return (
      <AuthLayout gauge title="Name your workspace" subtitle={`Signed in as ${auth.pending.email}`}>
        <Notice notice={auth.notice} />
        <AuthWorkspaceStep auth={auth} />
      </AuthLayout>
    )
  }

  const checkout = /checkout|cart/.test(auth.next)

  return (
    <AuthLayout
      gauge
      title="Sign in"
      subtitle={checkout
        ? 'Sign in to complete checkout — creating an account is free.'
        : 'Welcome back. Sign in to your workspace.'}
    >
      <Notice notice={auth.notice} />
      <GoogleButton onClick={auth.signInGoogle} disabled={!auth.configured || auth.busy} />
      <Divider />
      <form onSubmit={(e) => { e.preventDefault(); auth.signInEmail({ email, password }) }}>
        <Field
          label="Email" name="email" type="email" value={email} onChange={setEmail}
          placeholder="you@company.com" autoComplete="email" required autoFocus disabled={!auth.configured}
        />
        <Field
          label="Password" name="password" type="password" value={password} onChange={setPassword}
          placeholder="Your password" autoComplete="current-password" required disabled={!auth.configured}
        />
        <p className="rrauth__inline-right">
          <Link className="rrauth__link" to={`/forgot-password${nextQ}`}>Forgot your password?</Link>
        </p>
        <SubmitButton busy={auth.busy} disabled={!auth.configured}>Sign in</SubmitButton>
      </form>

      {!auth.configured && (
        <p className="rrauth__notice rrauth__notice--info" style={{ marginTop: 16 }}>
          Sign-in isn’t configured in this build.
        </p>
      )}

      <AltLine>
        New to ReRight?{' '}
        <Link className="rrauth__link rrauth__link--accent" to={`/signup${nextQ}`}>Sign up</Link>
      </AltLine>
    </AuthLayout>
  )
}
